import * as yup from "yup";

import { ApiResponse } from "@typeDefinitions/Api";
import { APIMethods } from "@typeDefinitions/enums";
import { getDataAPI } from "@utils/api";

export type GetSystemNotificationsResponse = ApiResponse<
  SystemNotificationDto[]
>;

export const getSystemNotificationsAPI =
  async (): Promise<GetSystemNotificationsResponse> => {
    const response = await getDataAPI(
      "/dietitian/system-notifications",
      APIMethods.GET,
    );
    return await fetchSystemNotificationResponseSchema.validate(response);
  };

const clientSchema = yup.object().shape({
  id: yup.number().required(),
  text: yup.string().required(),
  textEn: yup.string().required(),
  startedAt: yup.string().required(),
  endedAt: yup.string().required(),
});

const fetchSystemNotificationResponseSchema = yup.object().shape({
  data: yup.array().of(clientSchema).required(),
});

export interface SystemNotificationDto {
  id: number;
  text: string;
  textEn: string;
  startedAt: string;
  endedAt: string;
}
